'use strict'
import { CronJob as Cron } from 'cron'
import getLibtranslate from './getLibtranslate'
import noTranslatedTerms from './noTranslatedTerms'
import sendNoTranslateTerms from './sendNoTranslateTerms'

export default () => {
    
    let job = new Cron('*/20 * * * * *',async() => {
        let items = noTranslatedTerms()
        try {
            await sendNoTranslateTerms(items)
            if(items.length) {
                while(items.length) noTranslatedTerms().pop()
            }
            let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}
            await getLibtranslate(user.EMPRESA_ID)
        } catch( e ) {
            console.log(e)
        }
    })

    job.start()
}